import { useCurrentLocale } from '@locales/client';
import { useRouter } from 'next/navigation';
import { getLocalizedGamePath } from '@/shared/libs/get-localized-game-path';

type GameNavigationSource = Parameters<typeof getLocalizedGamePath>[1];

interface UseGameNavigationParams {
  isMobile?: boolean;
  isAuth?: boolean;
}

export function useGameNavigation({
  isMobile = true,
  isAuth = false,
}: UseGameNavigationParams = {}) {
  const locale = useCurrentLocale();
  const router = useRouter();

  const getGameInfoPath = (game: GameNavigationSource) =>
    getLocalizedGamePath(locale, game);
  const getGamePath = (game: GameNavigationSource, demo = false) =>
    `${getGameInfoPath(game)}/${demo ? 'demo' : 'play'}`;

  const onGameClick = (game: GameNavigationSource) => {
    if (!isMobile && isAuth) {
      router.push(getGamePath(game));
    } else {
      router.push(getGameInfoPath(game));
    }
  };

  return { getGamePath, getGameInfoPath, onGameClick };
}
